import(/* webpackMode: "eager" */ "/home/runner/work/geounique/geounique/src/app/error.tsx");
